module.exports = __webpack_public_path__ + "img/42.21c093dd.jpg";